import { useEffect, useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api } from "@/lib/api";

export const useClients = () => {
  const [clients, setClients] = useState([]);
  useEffect(() => { api.get("/clients").then((r) => setClients(r.data)).catch(() => {}); }, []);
  return clients;
};

export const ClientSelect = ({ value, onChange, clients, testId = "client-select", allowNone = true, noneLabel = "No client", className = "" }) => (
  <Select value={value || "none"} onValueChange={(v) => onChange(v === "none" ? "" : v)}>
    <SelectTrigger data-testid={testId} className={`bg-slate-950/60 border-slate-700 ${className}`}><SelectValue placeholder="Select client" /></SelectTrigger>
    <SelectContent className="bg-slate-900 border-slate-700">
      {allowNone && <SelectItem value="none">{noneLabel}</SelectItem>}
      {clients.map((c) => <SelectItem key={c.id} value={c.id} data-testid={`${testId}-option-${c.id}`}>{c.name}{c.company ? ` — ${c.company}` : ""}</SelectItem>)}
    </SelectContent>
  </Select>
);
